//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import copyIcon from 'images/sheet.png'
import MenuOption from './MenuOption'

const PathReports = props => {
  const {
    hasHighlighted,
    idRoot,
    setModalTemplate,
  } = props

  return (
    <MenuOption
      enabled={hasHighlighted}
      icon={copyIcon}
      id={`${idRoot}projects-path-reports`}
      label={'Project Reports'}
      modalTemplate={'path-reports'}
      setModalTemplate={setModalTemplate} />
  )
}

PathReports.propTypes = {
  hasHighlighted: bool.isRequired,
  idRoot: string.isRequired,
  setModalTemplate: func.isRequired,
}

export default PathReports
